import React from "react";
import Header from "../../components/header/Header.component";
import Footer from "../../components/footer/Footer.component";

import "../top-airlines/top-airlines.style.css";
import BannerSearchForm from "../../components/flight-search-form/BannerSearchForm.component";
import FlightSearchForm from "../../components/flight-search-form/FlightSearchForm.component";

export const Europe = () => {
  return (
    <>
      <div className="home-banner">
        <div className="cm-page-center">
          <div className="search-banner">
            <h1>Let AirFareHQ bring your dream vacation to new heights.</h1>
            <FlightSearchForm />
          </div>
        </div>
      </div>
      <div className="cm-section cm-page-center">
        {/* <BannerSearchForm depVal={data} urlVal={dataToSend} /> */}
        <div className="ryan-air">
          <div className="ryanair-title">
            <h1>Europe</h1>
          </div>
          <div className="ryanair-content">
            <p>
              Europe offers a wide variety of attractions, from serene locations
              to immaculate lake vistas. By visiting Europe, tourists may follow
              in the footsteps of important historical, political, and religious
              people and discover some of the most important events in human
              history. The most alluring aspect of Europe is its abundance of
              attractions, including the cradle of democracy in Athens,
              Renaissance art in Florence, beautiful canals in Venice,
              Napoleonic majesty in Paris, and the magnificent charms of
              Andalucian Moorish palaces. Traveling to Europe gives you the
              chance to sample excellent wines and real Italian, French, and
              other cuisines. Therefore, if you're considering a trip to Europe,
              start booking your flights to Europe right now.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
